import {
  GET_DIGITAL_CARD_STATES,
  GET_DIGITAL_CARD_STATES_SUCCESS,
  GET_DIGITAL_CARD_STATES_ERROR,
  GET_DIGITAL_CARD_STATES_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDigitalCardStates = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIGITAL_CARD_STATES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_CARD_STATES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_CARD_STATES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DIGITAL_CARD_STATES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDigitalCardStates;
